import { useEffect, useMemo, useState } from "react";
import { FundItem } from "../models/Fund";
import { useAppSelector } from "../store/reducers/store"
import { Utilities } from "../utility/utils";

const useIsFullable = (): boolean =>{
    const allFunds = useAppSelector(state => state.libraryOfFundsReducer.allFunds);
    const active = useAppSelector(state => state.createPortfolio.portfolio.retailInvestors);
    const portfolioFunds = useAppSelector(state => state.createPortfolio.portfolio.funds);
    const fundraisingTarget = useAppSelector(state => state.createPortfolio.portfolio.fundraisingTarget);
    const [isFullable, setIsFullable] = useState(!active);

    useEffect(() => {
        if (active && allFunds !== undefined){
            const selectedFunds: FundItem[] = [];
            for(const f of portfolioFunds){
                selectedFunds.push(allFunds.find(fu => fu.id === f.id) as FundItem)
            }
            setIsFullable(Utilities.canFulfillPortfolio(fundraisingTarget, selectedFunds));
        }
    },[allFunds, portfolioFunds]);

    return !active || isFullable;
}

export default useIsFullable;